import { Icon } from '@mdvip/shared/components/blocks/Icon';
import { Alert, AlertDescription, AlertTitle } from '@mdvip/shared/components/ui/alert';
import { useErrorTranslation } from '@mdvip/shared/hooks/useErrorTranslation';
import { extractGqlErrorCode } from '@mdvip/shared/lib/gqlErrors';
import { useTranslation } from 'react-i18next';

interface PracticeInfoErrorProps {
  error: unknown;
}

/** Any `usePracticeInfo` failure other than `NOT_FOUND` — follows the same extractGqlErrorCode +
 * useErrorTranslation pattern as `ProfileDetailsCardError`, with its own title copy. */
export function PracticeInfoError({ error }: PracticeInfoErrorProps) {
  const { t } = useTranslation('members');
  const tError = useErrorTranslation();
  return (
    <Alert variant="destructive" data-slot="practice-info-error">
      <Icon name="alertTriangle" weight="solid" />
      <AlertTitle>{t('profile.physician.loadErrorTitle')}</AlertTitle>
      <AlertDescription>{tError(extractGqlErrorCode(error))}</AlertDescription>
    </Alert>
  );
}
